import React, { FC, useMemo } from 'react'
import { Box } from 'transfix-ui/core'
import { IEquipmentAttributes } from 'types'
import { BulletGroup } from './BulletGroup'

export interface ITemperatureProps {
  attributes: IEquipmentAttributes
}

export const Temperature: FC<ITemperatureProps> = ({ attributes }) => {
  const { fixedTempControl, maxTempControl, minTempControl, precool } = attributes || {}
  const items = useMemo(
    () => [
      {
        id: 'precool',
        show: !!precool,
        component: (
          <Box key='precool' component='span'>
            Precool {precool}° F
          </Box>
        ),
      },
      {
        id: 'minTempControl',
        show: !!minTempControl,
        component: (
          <Box key='minTempControl' component='span'>
            Min {minTempControl}° F
          </Box>
        ),
      },
      {
        id: 'maxTempControl',
        show: !!maxTempControl,
        component: (
          <Box key='maxTempControl' component='span'>
            Max {maxTempControl}° F
          </Box>
        ),
      },
      {
        id: 'fixedTempControl',
        show: !!fixedTempControl,
        component: (
          <Box key='fixedTempControl' component='span'>
            Fixed {fixedTempControl}° F
          </Box>
        ),
      },
    ],
    [precool, minTempControl, maxTempControl, fixedTempControl]
  )

  return <BulletGroup items={items} />
}
